export var _menuTriggerTheme = {
  baseStyle: {
    display: 'inline-block',
    width: '100%',
    height: '100%',
    position: 'relative',
    _readOnly: {
      cursor: 'default'
    },
    _disabled: {
      cursor: 'not-allowed'
    }
  }
};
//# sourceMappingURL=_MenuTrigger.theme.js.map